import './App.css';
import { Layout } from 'antd';
import ResetPassword from './pages/resetPassword/ResetPassword';
import RolesPage from './pages/roles/RolesPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import VerifyEmailError from './pages/errorPage/VerifyEmailError';
import Signup from './pages/register/Signup';

const { Content, Header } = Layout;


function App() {
  return (
    <BrowserRouter>
      <Layout className='layout'>
        <Header>
          <div id="logo"></div>
        </Header>
        <Content>
          <Routes>
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/error/verify-email" element={<VerifyEmailError />} />
            <Route path="/roles" element={<RolesPage />} />
          </Routes>
        </Content>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
